module.exports = __webpack_public_path__ + "img/mission-diversity-girls.jpg?c6b3c48e290be126b39aefae571a677c";